export default __webpack_public_path__ + "static/media/seo.d3315eb9.jpg";